var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237\\u5217\\u8868\\u9875-copy-17",
    transform: "translate(-48.000000, -412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(35.000000, 398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(13.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21",
    fill: "#A0A7B4",
    x: 0,
    y: 5,
    width: 13,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    stroke: "#A0A7B4",
    strokeWidth: 1.5,
    x: 3,
    y: 0,
    width: 7,
    height: 12,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18761907,10.1591224 L7.18761907,11.7859001 C7.18761907,12.1791537 6.85998537,12.5 6.45841271,12.5 C6.05684005,12.5 5.72920636,12.1791537 5.72920636,11.7859001 L5.72920636,10.1591224 C5.29487033,9.91155047 5,9.45586195 5,8.92863337 C5,8.1395248 5.65305366,7.5 6.45885546,7.5 C7.26465726,7.5 7.91771092,8.1395248 7.91771092,8.92863337 C7.91726817,9.45586195 7.62239784,9.91155047 7.18761907,10.1591224 Z",
    id: "Path",
    fill: "#0A0E16"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.856c29fa710a9a9b5c7a272bc1714dd3.svg";
export { ForwardRef as ReactComponent };